// Imports live with the data (`/imports`, from an object's import menu): old links and bookmarks land there.
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_settings/settings/imports')({
  beforeLoad: () => {
    throw redirect({ to: '/imports', replace: true });
  },
});
